import { render, staticRenderFns } from "./articles-grid.vue?vue&type=template&id=4dae3c0a&scoped=true&"
import script from "./articles-grid.vue?vue&type=script&lang=js&"
export * from "./articles-grid.vue?vue&type=script&lang=js&"
import style0 from "./articles-grid.vue?vue&type=style&index=0&id=4dae3c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dae3c0a",
  null
  
)

export default component.exports